<div class="col-12 inner-data">
	<div class="filter-icon pb-4">
		<span class="clickable" id="open-filter" (click)="openFilter = !openFilter"><i class="fa fa-filter"
				aria-hidden="true"></i> Filter</span>
		<span style="float: right;" class="clickable" id="refresh" (click)="refreshList()">
			<i class="fas fa-sync-alt"></i> Refresh
		</span>
	</div>
	<div class="relay-margin-top-10" *ngIf="openFilter">
		<form class="row" [formGroup]="searchQueueForm" (submit)="searchQueue(searchQueueForm.value)">
			<div class="col">
				<ng-select class="custom-style" [multiple]="true" id="my-project" chosen formControlName="projectIds"
					placeholder="Select Project(s)" [items]="userProjects" bindLabel="name" bindValue="id"
					(change)="getUsersByProject(projectIdsValue)">
					<ng-template ng-option-tmp let-item="item">
						<div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
					</ng-template>
				</ng-select>
			</div>
			<div class="col" [hidden]="!projectIdsValue || projectIdsValue?.length === 0">
				<ng-select class="custom-style" [multiple]="true" id="project-user" chosen formControlName="userIds"
					placeholder="Select Users(s)" bindLabel="displayName" bindValue="id" [items]="projectUsers"
					[ngClass]="{'disabled': !projectIdsValue || projectIdsValue?.length === 0}"></ng-select>

			</div>
			<div class="col" *ngIf="!projectIdsValue || projectIdsValue?.length === 0">
				<input id="search-userName" class="form-control form-control-sm" placeholder="Search User"
					formControlName="userName">
			</div>
			<div class="col">

				<ng-select class="custom-style" chosen formControlName="executionStatus" [items]="executionStatuses"
					placeholder="Select Status" [clearable]="true"></ng-select>
			</div>
			<div class="col">
				<input id="search-keyword" class="form-control form-control-sm" placeholder="Search Keyword"
					formControlName="keyword">
			</div>
			<div class="col-12 mt-3">
				<button type="submit" class="btn btn-sm btn-primary mr-2">Search</button>
				<button type="clear" class="btn btn-sm btn-warning" (click)="clearFilterQueue()">Clear</button>
			</div>
		</form>
	</div>
	<div class="table-responsive queue-table">
		<table class="table table-sm">
			<thead>
				<tr class="text-center font-bold">
					<td class="text-left" (click)="sortByColumn('name')">Testname</td>
					<td (click)="sortByColumn('loadTestType')">Type</td>
					<td width="13%" (click)="sortByColumn('location')">Location</td>
					<td title="Transactions per minute" (click)="sortByColumn('noOfUsers')">Users/TPM</td>
					<td (click)="sortByColumn('startTime')">Schedule Date & Time (PST)</td>
					<td (click)="sortByColumn('status')">Status</td>
					<td *ngIf="userData.perfLabAdmin" (click)="sortByColumn('userName')">Created By</td>
					<td></td>
				</tr>
			</thead>
			<tbody>
				<tr *ngIf="this.queueData.length === 0">
					<td colspan="8">No data found</td>
				</tr>
				<tr *ngFor="let queueData of queueData.performanceRequests">
					<td>

						<a> <i class="fas fa-link" ngbTooltip="Go to Testcase"
								(click)="getTestCaseList(queueData.testCase.id)"></i></a>
						<a class="text-truncate"
							[routerLink]="['/performance/loadTesting/result', queueData.id, 'queue']"
							title="{{queueData.testCase.name}}"
							style="padding-left: 0.2em;">{{queueData.testCase?.name}}</a>
					</td>
					<td class="text-center">{{queueData.testCase?.loadTestType}}</td>
					<td class="text-center">
						<a [routerLink]="['/performance/loadTesting/result', queueData.id, 'queue']">{{queueData.location
							? queueData.location : 'NA'}}</a>
					</td>
					<!-- <td class="text-center" *ngIf="userData.perfLabAdmin || userData.superAdmin">
						<img src="/assets/images/performance/parallel.png" width="20px" *ngIf="queueData.parallelFlow" ngbTooltip="Formal run">
						<img src="/assets/images/performance/sequential.png" width="20px" *ngIf="!queueData.parallelFlow" ngbTooltip="Dry run ">
					</td> -->

					<td class="text-center">
						<a [routerLink]="['/performance/loadTesting/result', queueData.id, 'queue']">{{queueData.noOfUsers
							> 9 ?
							queueData.noOfUsers : '0' + queueData.noOfUsers}}</a>
					</td>
					<td class="text-center"
						title="{{queueData.status === 'SCHEDULED' ? 'Results are not ready' : null}}">
						<a [routerLink]="['/performance/loadTesting/result', queueData.id, 'queue']">
							{{queueData.startTime | date: 'd-MM-yy, hh:mm:ss a'}} - {{queueData.endTime | date:
							'd-MM-yy, hh:mm:ss a'}}
						</a>
					</td>
					<td class="text-center">
						<img src="/assets/images/performance/completed.png" width="20px"
							*ngIf="queueData.status === 'PASSED'" ngbTooltip="{{queueData.status}}">
						<img src="/assets/images/performance/pending.png" width="20px"
							*ngIf="queueData.status === 'PENDING'" ngbTooltip="{{queueData.status}}">
						<img src="/assets/images/performance/failed.png" width="20px"
							*ngIf="queueData.status === 'FAILED' && queueData.errorMessage !== null"
							ngbTooltip="{{queueData.status}} : {{queueData.errorMessage}}">
						<img src="/assets/images/performance/failed.png" width="20px"
							*ngIf="queueData.status === 'FAILED' && queueData.errorMessage === null"
							ngbTooltip="{{queueData.status}}">
						<img src="/assets/images/performance/abort2.png" width="20px"
							*ngIf="queueData.status === 'ABORTED'" ngbTooltip="{{queueData.status}}">
						<img src="/assets/images/performance/inprogress.png" width="20px"
							*ngIf="queueData.status === 'IN_PROGRESS'" ngbTooltip="{{queueData.status}}">
						<img src="/assets/images/performance/scheduled.png" width="20px"
							*ngIf="queueData.status === 'SCHEDULED'" ngbTooltip="{{queueData.status}}">
					</td>
					<td class="text-center template-word-wrap" *ngIf="userData.perfLabAdmin"
						title="{{queueData.createdBy?.displayName}}">

						<span style="font-size:11px">{{queueData.createdBy ? queueData.createdBy.userName : ''}}</span>
					</td>
					<td class="text-right">
						<a class="fas fa-redo mr-1" title="Re-run"
							[routerLink]="['/performance/loadTesting/rerun/', queueData.id]" ngbTooltip="Re-run"
							placement="bottom-right"></a>
						<img class="clickable" src="/assets/images/icons/abort.png" width="16px"
							(click)="abortRunningTest(queueData.id)" alt="Abort" ngbTooltip="Abort"
							placement="bottom-right"
							*ngIf="queueData.status === 'SCHEDULED' || queueData.status === 'IN_PROGRESS' || queueData.status === 'PENDING' ">
						<i class="fas fa-trash-alt text-danger ml-1 clickable"
							*ngIf="queueData.status !== 'SCHEDULED' && userData.perfLabAdmin" ngbTooltip="Delete"
							placement="bottom-right" (click)="deleteQueueRes(queueData.id)"></i>
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<!-- Pagination -->
	<div class="row">
		<div class="col">Results : {{queueData.count || 0}} </div>
		<div class="col-1"
			*ngIf="queueData.performanceRequests !== undefined && queueData.performanceRequests.length > 0">
			<select class="form-control form-control-sm" (change)="onSizeChange(pageSize)" [(ngModel)]="pageSize">
				<option>15</option>
				<option>25</option>
				<option>50</option>
				<option>100</option>
			</select>
		</div>
		<div class="col-md-auto"
			*ngIf="queueData.performanceRequests !== undefined && queueData.performanceRequests.length > 0">
			<ngb-pagination [collectionSize]="queueData.count" size="sm" [maxSize]="5" [pageSize]="pageSize"
				[(page)]="page" [boundaryLinks]="true" [rotate]="true"
				(pageChange)="onPageChange($event)"></ngb-pagination>
		</div>
	</div>
</div>